import { getp, setp } from './getProp';

export function updateQueryMergeResults(dataPath) {
  return (prev, { fetchMoreResult }) => {
    if (!fetchMoreResult) return prev;
    const n = Object.assign({}, prev, fetchMoreResult);
    setp(n, dataPath, [
      ...getp(prev, dataPath),
      ...getp(fetchMoreResult, dataPath),
    ]);
    // console.log('Merged fetch results', prev, fetchMoreResult, n);
    return n;
  };
}

export function updateQueryNewResults() {
  return (prev, { fetchMoreResult }) => {
    if (!fetchMoreResult) return prev;
    const n = Object.assign({}, prev, fetchMoreResult);
    // console.log('Kept new fetch results', prev, fetchMoreResult, n);
    return n;
  };
}



// WEBPACK FOOTER //
// ./src/helpers/updateQueryHelpers.js